import { render, staticRenderFns } from "./settles.vue?vue&type=template&id=3b3e722d&scoped=true&"
import script from "./settles.vue?vue&type=script&lang=js&"
export * from "./settles.vue?vue&type=script&lang=js&"
import style0 from "./settles.vue?vue&type=style&index=0&id=3b3e722d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e722d",
  null
  
)

export default component.exports